<section>
  <ids-mobile-header [scrollElement]="bgBaseScroll">
    <button
      id="overview-validated-not-editable"
      idsMobileHeaderControls
      idsIconButton
      title="{{ labelBtnBack }}"
      aria-label="{{ labelBtnBack }}"
      (click)="backPage()"
      (focus)="ariaLabelPage = false"
      class="ids-pb-5"
    >
      fechar
    </button>
  </ids-mobile-header>
</section>
<section
  style="overflow: scroll"
  #bgBaseScroll
  [attr.aria-hidden]="ariaLabelPage"
>
  <div class="ids-container ids-py-5">
    <div class="ids-row">
      <div class="ids-col-12">
        <ids-icon
          style="margin-bottom: 15px"
          aria-hidden="true"
          size="L"
          variant="error"
          >aviso_outline</ids-icon
        >
        <h1 class="ids-title -small -bold ids-py-2">
          Você precisa completar seus dados no app do Itaú
        </h1>
        <p class="ids-body-text description-pg ids-py-4" role="text" aria-label="Para continuar investindo, acesse o app Itaú e atualize seus dados pela rota: Home, em seguida Menu, em seguida Investir e gerenciar, em seguida Área do investidor e por fim Cadastro na Corretora">
          <span aria-hidden="true">
          Para continuar investindo, acesse o app Itaú e atualize seus dados
          pela rota: Home > Menu > Investir e gerenciar > Área do investidor >
          Cadastro na Corretora
          </span>
        </p>
        <p class="ids-body-text description-pg ids-py-4">
          Informações que devem ser atualizadas:
        </p>
      </div>
    </div>
    <div class="ids-col-12">
      <div class="ids-p-6 ids-d-flex ids-flex-column" style="row-gap: 1.5rem">
        <ol ids-list>
          <li *ngFor="let item of listStatus" idsLi lineOff>
            <span idsLiText [attr.aria-label]="item.step" class="ids-body-text -bold">{{ item.step }}</span>
          </li>
        </ol>
      </div>
    </div>
  </div>
</section>
